<!--Page-->
<template>
  <div class="page-container">
    <loader v-if="load"></loader>
    <div class="page" v-if="page">

      <!--Menus de la semaine-->
      <div class="page-content" v-if="pageSlug === 'menus-de-la-semaine' ">
        <slider></slider>
        <h1 id="title" class="page-title mt-5 mb-5 container">{{ page.title.rendered }}</h1>
        <div class="entry-content container">
            <week-menu-listing/>
        </div>
        <month-offers/>
      </div>

      <!--Galerie-->
      <div class="page-content" v-else-if="pageSlug === 'galerie'">
        <slider></slider>
        <h1 id="title" class="page-title mt-5 mb-5 container">{{ page.title.rendered }}</h1>
        <div class="entry-content container">
            <galerie-grid/>
        </div>
      </div>

      <!--Our-menu-->
      <div class="page-content" v-else-if="pageSlug === 'notre-carte'">
        <slider></slider>
        <h1 id="title" class="page-title mt-5 mb-5 container">{{ page.title.rendered }}</h1>
        <div class="entry-content container">
            <our-menu/>
        </div>
      </div>

      <!--Réservation-->
      <div class="page-content" v-else-if="pageSlug === 'reservation'">
        <h1 id="title" class="page-title mt-5 mb-5 container" data-aos="fade-down">{{ page.title.rendered }}</h1>
        <div class="entry-content container">
            <booking/>
        </div>
      </div>

      <!-- Restaurant
      <div class="page-content" v-else-if="pageSlug === 'restaurant'">
        <slider></slider>
        <h1 class="page-title mt-5 mb-5 container">{{ page.title.rendered }}</h1>
        <div class="entry-content container" v-html="page.content.rendered"></div>
      </div> -->

      <!--Contact-->
      <div class="page-content" v-else-if="pageSlug === 'contact'">
        <slider></slider>
        <h1 id="title" class="page-title mt-5 mb-5 container">{{ page.title.rendered }}</h1>
        <div class="entry-content container" >
          <div class="box-contact z-depth-4">
            <div class="row">
              <div class="col-12 col-lg-6 mb-5" data-aos="fade-right">
                <contact-form/>
              </div>
              <div class="col-12 col-lg-6" data-aos="fade-left">
                <div class="mapouter"><div class="gmap_canvas"><iframe width="" height="" id="gmap_canvas" src="https://maps.google.com/maps?q=Rue%20de%20l'H%C3%B4Rue%20de%20l'H%C3%B4pital%2039%2C%202800%20Del%C3%A9montpital%2039%2C%202800%20Del%C3%A9mont&t=&z=19&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Other page-->
      <div v-else class="page-content">
        <slider></slider>
        <h1 id="title" class="page-title mt-5 mb-5 container">{{ page.title.rendered }}</h1>
        <div class="entry-content container" v-html="page.content.rendered"></div>
      </div>

    </div>
  </div>
</template>
<script>
import api from '@/api'

// Components
import Loader from '@/components/Loader/Loader'
import Slider from '@/components/Slider/Slider'
import MonthOffers from '@/components/MonthOffers/MonthOffers'

// Pages
import WeekMenuListing from '@/components/WeekMenu/WeekMenuListing'
import GalerieGrid from '@/components/Galery/GalerieGrid'
import ContactForm from '@/components/ContactForm/ContactForm'
import OurMenu from '@/components/OurMenu/OurMenu'
import Booking from '@/components/Booking/Booking'

export default {
  components: {
    Slider,
    WeekMenuListing,
    GalerieGrid,
    Loader,
    ContactForm,
    OurMenu,
    Booking,
    MonthOffers
  },
  data () {
    return {
      load: true,
      page: null,
      pageSlug: ''
    }
  },
  methods: {
    /**
     * Fetch page
     * @param slug | WordPress page slug
     * @return void
     */
    fetchPage (slug) {
      let url = api.page + slug
      this.axios(url).then(response => {
        this.page = response.data[0]
        this.pageSlug = response.data[0].slug
        this.load = false
        // this.$Progress.stop()
        document.title = this.page.title.rendered + ' | ' + 'Komachi'
        // If meta description is not defined in WordPress admin pages.
        // Set default meta description
        if (this.page.acf.meta_des === undefined) {
          this.page.acf.meta_des = 'Nous vous proposons des plats familiaux japonais dans un cadre agréable, chaleureux et convivial. Ces mets seront sains et équilibrés.'
        } else {
          document.head.querySelector('meta[name=description]').content = this.page.acf.meta_des
        }
      }).catch(error => {
        console.log('err', error)
        this.$router.push({path: 'error/404'})
        document.head.querySelector('meta[name=prerender-status-code]').content = '404'
      })
    }
  },
  watch: {
    '$route' (to) {
      // react to route changes...
      this.fetchPage(to.params.slug)
    }
  },
  mounted () {
    this.fetchPage(this.$route.params.slug)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Page.vue